export default "__VITE_ASSET__3f6fcda9__"